module.exports = __webpack_public_path__ + "img/logo-movies.d1aa3f27.png";